// Logs to the browser console only in lower environments; silent in pre-prod and prod.
import { getEnvFromUrl } from '../config';

// Environments where console output is suppressed.
const RESTRICTED_ENVS = ['pre-prod', 'prod'];

// Returns true only when running in a dev build or a lower (non pre-prod/prod) environment.
const isConsoleAllowed = () => process.env.NODE_ENV === 'development'
  || process.env.NODE_ENV === 'test'
  || !RESTRICTED_ENVS.includes(getEnvFromUrl(window.location));

// console.log gated to lower environments only.
export const lowerEnvConsoleLog = (...args) => {
  if (isConsoleAllowed()) {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
};

// console.warn gated to lower environments only.
export const lowerEnvConsoleWarn = (...args) => {
  if (isConsoleAllowed()) {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
};

export default lowerEnvConsoleLog;
